export default "__VITE_ASSET__QpJ2$TKL__"